/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx';
import {FC, useEffect, useRef, useState} from 'react';
import { Link } from 'react-router-dom';
import {/*defaultLogs,*/ KTIcon, toAbsoluteUrl } from '../../../helpers';
import moment from 'moment';


const HeaderNotificationsMenu: FC<{ subscriptions: any, amendments: any, serviceRequests: any, promos: any, setTabSelected: any, tabReadStatus: any, handleUpdateNotif: any}> = ({ subscriptions = null, amendments = null, serviceRequests = null, promos = null, setTabSelected = null, tabReadStatus = null, handleUpdateNotif = null}) => {
    const basePromoUrl = process.env.REACT_APP_BACK_OFFICE_URL;
    const customerNum = localStorage.getItem('customerNum') || null;
    

    const menuRef = useRef(null);

    const [loading, setLoading] = useState(false);

    const handleTabChange = async () => {
        const activeTabElement = document.querySelector('.nav-link.active');
        const activeTab = activeTabElement?.getAttribute('href');
        setTabSelected(activeTab)
    };

    useEffect(() => {
        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    const targetElement = mutation.target as HTMLElement;
                    if (targetElement.classList.contains('show')) {
                        const tabs = (document.querySelectorAll('a[data-bs-toggle="tab"]'));
                        handleTabChange()

                        tabs.forEach((tab) => {
                            tab.addEventListener('shown.bs.tab', handleTabChange);
                        });
                    }
                }
            });
        });

        if (menuRef.current) {
            observer.observe(menuRef.current, {
                attributes: true,
            });
        }

        return () => {
            // tabs.forEach((tab) => {
            //     tab.removeEventListener('shown.bs.tab', handleTabChange);
            // });

            if (menuRef.current) {
                observer.disconnect();
            }
        };
    }, []);


    return (
        <div
            className="menu menu-sub menu-sub-dropdown menu-column w-600px w-lg-575px"
            data-kt-menu="true"
            ref={menuRef}
        >
            <div className="d-flex flex-column bgi-no-repeat rounded-top bg-primary">
                <h3 className="text-white fw-bold px-9 mt-10 mb-6">
                    Notifications
                </h3>
                <ul className="nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9">
                    <li
                        className="nav-item"
                        hidden={customerNum !== null && customerNum !== ''}
                    >
                        <a
                            className="nav-link text-white opacity-75 opacity-state-100 pb-4 active"
                            data-bs-toggle="tab"
                            href="#kt_topbar_notifications_1"
                            aria-selected={true}
                        >
                            Subscription
                        </a>
                    </li>
                    <li
                        className="nav-item"
                    >
                        <a
                            className="nav-link text-white opacity-75 opacity-state-100 pb-4"
                            data-bs-toggle="tab"
                            href="#kt_topbar_notifications_2"
                        >
                            Service request
                        </a>
                    </li>
                    <li
                        className="nav-item"
                    >
                        <a
                            className="nav-link text-white opacity-75 opacity-state-100 pb-4"
                            data-bs-toggle="tab"
                            href="#kt_topbar_notifications_3"
                        >
                            Amendment
                        </a>
                    </li>
                    <li
                        className="nav-item"
                    >
                        <a
                            className="nav-link text-white opacity-75 opacity-state-100 pb-4"
                            data-bs-toggle="tab"
                            href="#kt_topbar_notifications_4"
                        >
                            Promo
                        </a>
                    </li>
                </ul>
            </div>

            <div className="tab-content">
                <div
                    className="tab-pane fade active show"
                    id="kt_topbar_notifications_1"
                    role="tabpanel"
                >
                    <div className="scroll-y mh-325px my-5 px-8">
                        {!subscriptions || subscriptions?.length === 0 ? (
                            loading ? (
                                <span
                                    className="indicator-progress text-center"
                                    style={{ display: 'block' }}
                                >
                                    Please wait...{' '}
                                    <span className="spinner-border spinner-border-sm align-middle"></span>
                                </span>
                            ) : (
                                <div className="d-flex flex-column px-9">
                                    <div className="pt-5 pb-0 mb-5">
                                        <div className="text-center text-gray-600 fw-bold pt-1">
                                            There's no notification displayed
                                        </div>
                                    </div>

                                    <div className="text-center px-4">
                                        <img
                                            className="w-50 mb-12"
                                            alt="metronic"
                                            src={toAbsoluteUrl(
                                                '/media/pgn/Empty state.png'
                                            )}
                                        />
                                    </div>
                                </div>
                            )
                        ) : (
                            subscriptions?.map((log: any, index) => (
                                <div
                                    key={`log${index}`}
                                    className="d-flex flex-stack py-4"
                                >
                                    <div className="d-flex align-items-center me-2">
                                        <span
                                            className={clsx(
                                                'd-flex justify-content-center badge text-truncate',
                                                `badge-light-${log?.docStatus == 'Verified'
                                                    ? 'success'
                                                    : log?.docStatus ==
                                                        'Rejected'
                                                        ? 'danger'
                                                        : 'warning'
                                                }`,
                                                'me-4'
                                            )}
                                        >
                                            {log?.docNumber}
                                        </span>
                                        <div className="text-gray-800 text-hover-primary fw-bold text-truncate">
                                            {log?.namaPerusahaan}
                                        </div>
                                        <span
                                            className={clsx(
                                                'd-flex justify-content-center badge text-truncate',
                                                `badge-light-${log?.docStatus == 'Verified'
                                                    ? 'success'
                                                    : log?.docStatus ==
                                                        'Rejected'
                                                        ? 'danger'
                                                        : 'warning'
                                                }`,
                                                'me-4'
                                            )}
                                        >
                                            {log?.docStatus}
                                        </span>
                                        <span className="badge badge-light fs-8">
                                            {moment(log?.modifiedOn).fromNow()}
                                        </span>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>

                    {subscriptions && subscriptions.length > 0 && (
                        <div className="py-3 text-center border-top">
                            <Link
                                to="/gas-subscription/1"
                                className="btn btn-color-gray-600 btn-active-color-primary"
                            >
                                View All{' '}
                                <KTIcon
                                    iconName="arrow-right"
                                    className="fs-5"
                                />
                            </Link>
                        </div>
                    )}
                </div>

                <div
                    className="tab-pane fade"
                    id="kt_topbar_notifications_2"
                    role="tabpanel"
                >
                    <div className="scroll-y mh-325px my-5 px-8">
                        {!serviceRequests || serviceRequests?.length === 0 ? (
                            loading ? (
                                <span
                                    className="indicator-progress text-center"
                                    style={{ display: 'block' }}
                                >
                                    Please wait...{' '}
                                    <span className="spinner-border spinner-border-sm align-middle"></span>
                                </span>
                            ) : (
                                <div className="d-flex flex-column px-9">
                                    <div className="pt-5 pb-0 mb-5">
                                        <div className="text-center text-gray-600 fw-bold pt-1">
                                            There's no notification displayed
                                        </div>
                                    </div>

                                    <div className="text-center px-4">
                                        <img
                                            className="w-50 mb-12"
                                            alt="metronic"
                                            src={toAbsoluteUrl(
                                                '/media/pgn/Empty state.png'
                                            )}
                                        />
                                    </div>
                                </div>
                            )
                        ) : (
                            serviceRequests?.map((item: any, index) => (
                                <div
                                    key={`log${index}`}
                                    className="d-flex flex-stack py-4"
                                >
                                    <div className="d-flex align-items-center me-2">
                                        <span
                                            className={clsx(
                                                'd-flex justify-content-center badge text-truncate',
                                                `badge-light-${item?.docStatus == 'approve'
                                                    ? 'success'
                                                    : item?.docStatus ==
                                                        'reject'
                                                        ? 'danger'
                                                        : 'warning'
                                                }`,
                                                'me-4'
                                            )}
                                        >
                                            {item?.submission_number}
                                        </span>
                                        <div
                                            className="text-gray-800 fw-bold text-truncate"
                                            style={{ width: '240px' }}
                                        >
                                            {item?.product_name}
                                        </div>
                                        <span
                                            className={clsx(
                                                'd-flex justify-content-center badge text-truncate',
                                                `badge-light-${item?.docStatus == 'approve'
                                                    ? 'success'
                                                    : item?.docStatus ==
                                                        'reject'
                                                        ? 'danger'
                                                        : 'warning'
                                                }`,
                                                'me-4'
                                            )}
                                        >
                                            {item?.status}
                                        </span>
                                        <span className="badge badge-light fs-8">
                                            {moment(
                                                item?.date_submitted
                                            ).fromNow()}
                                        </span>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                    {serviceRequests && serviceRequests.length > 0 && (
                        <div className="py-3 text-center border-top">
                            <Link
                                to="/customer-support/1"
                                className="btn btn-color-gray-600 btn-active-color-primary"
                            >
                                View All{' '}
                                <KTIcon
                                    iconName="arrow-right"
                                    className="fs-5"
                                />
                            </Link>
                        </div>
                    )}
                </div>
                <div
                    className="tab-pane fade"
                    id="kt_topbar_notifications_3"
                    role="tabpanel"
                >
                    <div className="scroll-y mh-325px my-5 px-8">
                        {!amendments || amendments?.length === 0 ? (
                            loading ? (
                                <span
                                    className="indicator-progress text-center"
                                    style={{ display: 'block' }}
                                >
                                    Please wait...{' '}
                                    <span className="spinner-border spinner-border-sm align-middle"></span>
                                </span>
                            ) : (
                                <div className="d-flex flex-column px-9">
                                    <div className="pt-5 pb-0 mb-5">
                                        <div className="text-center text-gray-600 fw-bold pt-1">
                                            There's no notification displayed
                                        </div>
                                    </div>

                                    <div className="text-center px-4">
                                        <img
                                            className="w-50 mb-12"
                                            alt="metronic"
                                            src={toAbsoluteUrl(
                                                '/media/pgn/Empty state.png'
                                            )}
                                        />
                                    </div>
                                </div>
                            )
                        ) : (
                            amendments?.map((item: any, index) => (
                                <div
                                    key={`log${index}`}
                                    className="d-flex flex-stack py-4"
                                >
                                    <div className="d-flex align-items-center me-2">
                                        <span
                                            className={clsx(
                                                'd-flex justify-content-center badge text-truncate',
                                                `badge-light-${item?.docStatus == 'approve'
                                                    ? 'success'
                                                    : item?.docStatus ==
                                                        'reject'
                                                        ? 'danger'
                                                        : 'warning'
                                                }`,
                                                'me-4'
                                            )}
                                        >
                                            {item?.docNumber}
                                        </span>
                                        <div
                                            className="text-gray-800 fw-bold text-truncate"
                                            style={{ width: '240px' }}
                                        >
                                            {item?.penyebabAmandemen}
                                        </div>
                                        <span
                                            className={clsx(
                                                'd-flex justify-content-center badge text-truncate',
                                                `badge-light-${item?.docStatus == 'approve'
                                                    ? 'success'
                                                    : item?.docStatus ==
                                                        'reject'
                                                        ? 'danger'
                                                        : 'warning'
                                                }`,
                                                'me-4'
                                            )}
                                        >
                                            {item?.docStatus}
                                        </span>
                                        <span className="badge badge-light fs-8">
                                            {moment(item?.createdOn).fromNow()}
                                        </span>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                    {amendments && amendments.length > 0 && (
                        <div className="py-3 text-center border-top">
                            <Link
                                to="/amendment/1"
                                className="btn btn-color-gray-600 btn-active-color-primary"
                            >
                                View All{' '}
                                <KTIcon
                                    iconName="arrow-right"
                                    className="fs-5"
                                />
                            </Link>
                        </div>
                    )}
                </div>

                <div
                    className="tab-pane fade"
                    id="kt_topbar_notifications_4"
                    role="tabpanel"
                >
                    <div className="scroll-y mh-325px my-5 px-8">
                        {!promos || promos?.length === 0 ? (
                            loading ? (
                                <span
                                    className="indicator-progress text-center"
                                    style={{ display: 'block' }}
                                >
                                    Please wait...{' '}
                                    <span className="spinner-border spinner-border-sm align-middle"></span>
                                </span>
                            ) : (
                                <div className="d-flex flex-column px-9">
                                    <div className="pt-5 pb-0 mb-5">
                                        <div className="text-center text-gray-600 fw-bold pt-1">
                                            There's no notification displayed
                                        </div>
                                    </div>

                                    <div className="text-center px-4">
                                        <img
                                            className="w-50 mb-12"
                                            alt="metronic"
                                            src={toAbsoluteUrl(
                                                '/media/pgn/Empty state.png'
                                            )}
                                        />
                                    </div>
                                </div>
                            )
                        ) : (
                            promos?.map((v: any) => {
                                return (
                                    <Link
                                        to={`/promotions/${v?.id}`}
                                        className="card card-custom w-100 mb-5"
                                    >
                                        <div className="card-body d-flex flex-wrap p-4">
                                            <img
                                                src={
                                                    v?.gambar_promo !== null
                                                        ? `${basePromoUrl}/Transaction/Promo/DisplayImage?imageName=${v?.gambar_promo}`
                                                        : `${toAbsoluteUrl(
                                                            '/media/misc/promo_default.jpg'
                                                        )}`
                                                }
                                                className="w-100 h-150px mb-1"
                                                style={{ objectFit: 'cover' }}
                                                alt=""
                                            />
                                            <div
                                                className="text-overflow-two fw-bold fs-5 mb-2 mt-2 text-overflow-two w-100">
                                                {v?.nama_promo}
                                            </div>
                                        </div>
                                    </Link>
                                );
                            })
                        )}
                    </div>
                    <div className="py-3 text-center border-top">
                        <Link
                            to="/promotions"
                            className="btn btn-color-gray-600 btn-active-color-primary"
                        >
                            View All{' '}
                            <KTIcon iconName="arrow-right" className="fs-5" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { HeaderNotificationsMenu };
